import { SvgIcon, SvgIconProps } from "@mui/material";

export default ({ ...props }: SvgIconProps) => (
  <SvgIcon height="24px" viewBox="0 -960 960 960" width="24px" {...props}>
    <path
      fill={"inherit"}
      transform="scale(0.8) translate(-160,-100)"
      d="M600-80q-127-48-203.5-158T320-484q0-91 36-172.5T458-800H320v-80h280v280h-80v-148q-57 51-88.5 119.5T400-484q0 102 54 187.5T600-167v87Z"
    />
    <path
      fill={"inherit"}
      fillOpacity={0.4}
      transform="scale(0.8) translate(400,-100) rotate(180,480,-480)"
      d="M600-80q-127-48-203.5-158T320-484q0-91 36-172.5T458-800H320v-80h280v280h-80v-148q-57 51-88.5 119.5T400-484q0 102 54 187.5T600-167v87Z"
    />
  </SvgIcon>
);
